module.exports = __webpack_public_path__ + "img/epicenter.17f2ca04.png";